// src/utils/payment-errors.ts
export enum PaymentErrorCode {
  USER_NOT_AUTHENTICATED = "USER_NOT_AUTHENTICATED",
  INVALID_AMOUNT = "INVALID_AMOUNT",
  PAYSTACK_NOT_LOADED = "PAYSTACK_NOT_LOADED",
  PAYMENT_INIT_FAILED = "PAYMENT_INIT_FAILED",
  PAYMENT_VERIFICATION_FAILED = "PAYMENT_VERIFICATION_FAILED",
  NETWORK_ERROR = "NETWORK_ERROR",
  UNKNOWN_ERROR = "UNKNOWN_ERROR",
}

export interface PaymentError {
  code: PaymentErrorCode;
  message: string;
  originalError?: any;
  retryable: boolean;
}

export class PaymentErrorHandler {
  static handle(error: any): PaymentError {
    console.error("Payment error:", error);

    // Network errors
    if (error.message?.includes("network") || error.code === "NETWORK_ERROR") {
      return {
        code: PaymentErrorCode.NETWORK_ERROR,
        message: "Network connection error. Please check your internet.",
        originalError: error,
        retryable: true,
      };
    }

    // Authentication errors
    if (error.message?.includes("authenticated") || error.code === "auth/") {
      return {
        code: PaymentErrorCode.USER_NOT_AUTHENTICATED,
        message: "Please sign in to complete payment",
        originalError: error,
        retryable: false,
      };
    }

    // Paystack script errors
    if (error.message?.includes("Paystack")) {
      return {
        code: PaymentErrorCode.PAYSTACK_NOT_LOADED,
        message: "Payment system failed to load. Please refresh.",
        originalError: error,
        retryable: true,
      };
    }

    // Default unknown error
    return {
      code: PaymentErrorCode.UNKNOWN_ERROR,
      message: "An unexpected error occurred",
      originalError: error,
      retryable: false,
    };
  }

  static isRetryable(error: PaymentError): boolean {
    return error.retryable;
  }
}
